import { useLocation } from "react-router-dom";

/**
 * Lightweight CSS-only page transition.
 * The wrapper re-mounts on route change (key={pathname}), triggering the
 * `pageFade` animation defined in index.css.
 */
export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <div key={pathname} className="page-fade">
      {children}
    </div>
  );
}
